







import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';

interface Data {}

interface Methods {}

interface Computed {}

interface Props {
  description: string;
}

export default Vue.extend({
  name: 'NoNotificationsPlug',
  props: {
    description: {
      type: String,
      default: () => '',
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
